import styled from "styled-components";

export default styled.div`

 
   .tp-container { 
     max-width: 100%;
     margin-top: 35px;
     
   }
  
   .name-your-business-container {
    padding-bottom: 8rem;
   
    .btn {
      width: -webkit-fill-available;
    }
  }

   .hero {     
     background-size: 365px, cover;   
     background-position: center bottom,
        center center;

     ${(props) => props.theme.media.md} { 
        height: 645px;
        background-position: calc(50% + 345px) bottom,
                        center center;
        background-size: auto, cover;                 
     }
     ${(props) => props.theme.media.lg} { 
        background-position: calc(50% + 550px) bottom,
                        center center;
     }
     position: relative;
     background-repeat: no-repeat;
     background-image: url(${(props) =>
       props.image}), url(/static/images/common-industry-hero.jpg);
   }   

   .hero-title {
     text-align: center;
     font-weight: 600;
     line-height: 1.2;
     margin-top: 1.4rem;
     margin-bottom: 1rem;
     font-size: 36px;
     @media (min-width: 320px) and (max-width: 400px) {
      font-size: 32px;
     }
     word-spacing: 0.54pt;
     line-height: 1.08;
     color: #3F5261;
  }

   .hero-title-2 {
    h2 {
     text-align: center;
     font-weight: 700;
     line-height: 1.2;
     margin-top: 0rem;
     margin-bottom: 1rem;
     font-size: 2.50rem;
     word-spacing: 0.54pt;
     line-height: 1.08;
     color: #3F5261;
    }
  }
  
  .hero-subtitle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    margin-bottom: 216px;
    p {
      font-size: 20px;
      font-weight: 400;
      line-height: 1.4;
      color: #3F5261;
      font-weight: 400;
      text-align: center;
      font-family: 'Poppins';
      max-width: 360px;

      strong {
        font-weight: 600;
      }
    }
  }



  ${(props) => props.theme.media.md} {
    .tp-container {
       margin-top: 20px;
       max-width 880px;
      .trustpilot-widget {
        overflow: hidden;
        max-width: none;
        iframe {
          height: 70px;
          
          //margin-top 20px;
          //transform: scale(1.2);
        }
      }
    }
 
   .name-your-business-container {
     padding-bottom: 8rem;
    
     .btn {
       width: auto;
     }
   }

    .hero-title {
      font-size: 50px;
      line-height: 1.2;
      display: block;
      max-width: 760px;
      margin: auto;
      margin-top: 7.3rem;
      margin-bottom: 1rem;
    }

    .hero-title-2 {
      h2 {
      font-size: 50px;
      line-height: 1.2;
      display: block;
      max-width: 700px;
      margin: auto;
      margin-top: 0.5rem;
      margin-bottom: 1rem;
      }
   }    

    .hero-subtitle {
      max-width: 700px;
      margin auto;
      padding-bottom: 1rem;
      height: auto;
   
      p {
        font-size:1.5rem;        
        margin: 0 auto;        
        text-align: center;
        margin-bottom:10px;
        max-width: 100%;
        strong {
          font-weight: 600;
        }
      }
    }
  }
`;
